import type {BioIconProps} from './common-types'

export function PointerIconArrow({...attributes}: BioIconProps) {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M7.66394 15.4881C7.03311 16.3089 5.72061 15.8806 5.69561 14.8456L5.49644 6.62892C5.49149 6.43171 5.5398 6.2368 5.63627 6.06472C5.73274 5.89263 5.87381 5.74974 6.04464 5.65106C6.21547 5.55238 6.40974 5.50158 6.607 5.50399C6.80427 5.5064 6.99724 5.56194 7.16561 5.66476L14.1823 9.94559C15.0656 10.4848 14.7806 11.8356 13.7548 11.9714L10.4323 12.4106C10.1439 12.4489 9.88227 12.5998 9.70561 12.8298L7.66394 15.4881Z"
        stroke="#4F4F4F"
        strokeLinejoin="round"
      />
      <path
        d="M0.5 5.50167H2.58333M5.70833 2.58333V0.5M3.015 3.01417L1.54167 1.54167M8.40167 3.01417L9.875 1.54167"
        stroke="#4F4F4F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
